/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation RatePlanEmailMutation($customerAccountIds: [ID!]!) {
  RatePlanEmail(customerAccountIds: $customerAccountIds) {
    message,
    status
  }
}
`
